import { consumeBackground } from "@/lib/consume/background"
import { consumeGeolocation } from "@/lib/geolocation/consume"

import { BookingSearchAddressInputComponent } from "@/components/Booking/BookingSearchAddressInput/component"

export const BookingSearchAddressInputConsumer = consumeBackground(
  consumeGeolocation(BookingSearchAddressInputComponent)
)
